var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentCollor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99976 0C4.03709 0 0 4.03761 0 9.00024C0 13.9629 4.03742 18 8.99976 18C13.9624 18 18 13.9629 18 9.00024C18 4.03756 13.9626 0 8.99976 0ZM8.99976 16.4405C4.89758 16.4405 1.56001 13.1025 1.56001 9.00024C1.56001 4.89805 4.89744 1.56048 8.99976 1.56048C13.1027 1.56048 16.44 4.89829 16.44 9.00024C16.44 13.1024 13.1028 16.4405 8.99976 16.4405Z",
    fill: "currentCollor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95712 13.9252C9.95712 14.4364 9.54267 14.851 9.0313 14.851C8.51992 14.851 8.10547 14.4364 8.10547 13.9252C8.10547 13.4139 8.51992 12.9992 9.0313 12.9992C9.54267 12.9992 9.95712 13.4138 9.95712 13.9252Z",
    fill: "currentCollor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0162 3.59462C9.73199 3.33959 9.4054 3.14948 9.03071 3.14948C8.65602 3.14948 8.32944 3.33959 8.04499 3.59462C7.69158 3.91124 7.66476 4.25873 7.69638 4.64322L8.30926 11.2819C8.34403 11.7074 8.61571 12.0266 9.03089 12.0266C9.44607 12.0266 9.71776 11.7076 9.75251 11.2819L10.3654 4.64322C10.3968 4.25872 10.37 3.91141 10.0162 3.59462H10.0162Z",
    fill: "currentCollor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackAlert);
export default __webpack_public_path__ + "static/media/blackAlert.695e57a9829c380b5742302319a9ebae.svg";
export { ForwardRef as ReactComponent };